import { useEffect, useState } from 'react';
import './sass/main.scss';
import { motion, AnimatePresence, AnimateSharedLayout } from 'framer-motion';

// Components
import Banner from './components/Banner';
import Loader from './components/Loader';
import About from './components/About';
import Projects from './components/Projects';
import Header from './components/Header';
import Socials from './components/Socials';
// import CustomCursor from "./components/CustomCursor";

// import locomotiveScroll from "locomotive-scroll";
import Footer from './components/Footer';

const MainHome = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loading
      ? document.querySelector('body').classList.add('loading')
      : document.querySelector('body').classList.remove('loading');
  }, [loading]);

  return (
    <AnimateSharedLayout type="crossfade">
      <AnimatePresence>
        <div className="app">
          {loading ? (
            <motion.div key="loader">
              <Loader setLoading={setLoading} />
            </motion.div>
          ) : (
            <>
              <Header />
              <Banner />
              {!loading && (
                <div className="transition-image final">
                  <motion.img
                    src={process.env.PUBLIC_URL + `/images/coder-zoomed.jpg`}
                    layoutId="main-coder"
                    transition={{
                      ease: [0.6, 0.01, -0.05, 0.95],
                      duration: 1.6,
                    }}
                  />
                </div>
              )}
              <About />
              <Projects />

              <Socials />
              <Footer />
            </>
          )}
        </div>
      </AnimatePresence>
    </AnimateSharedLayout>
  );
};

export default MainHome;
